<!-- Button trigger modal -->
<div style="text-align: right">
    <button type="button" class="btn btn-primary" data-toggle="modal" aria-label="Left Align" data-target="#addBranchModal">
        + Añadir Sucursal
    </button>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="addBranchModal" tabindex="-1" role="dialog" aria-labelledby="addBranchModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" id="addBranchModalLabel">Añadir Sucursal</h5>
            <button type="button" class="close modal-close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <form [formGroup]="addBranchForm" (ngSubmit)="addBranch()">
        <div class="modal-body">
            <div class="form-group">
                <label for="companyName">Compañía</label>
                <input type="text" class="form-control" id="companyName" formControlName="name">
            </div>
    
            <div class="form-group">
                <label for="addressLine1">Dirección Linea 1</label>
                <input type="text" class="form-control" id="addressLine1" formControlName="address1">
            </div>
    
            <div class="form-group">
                <label for="addressLine2">Dirección Linea 2</label>
                <input type="text" class="form-control" id="addressLine2" formControlName="address2">
            </div>
    
            <div class="form-group">
                <label for="city">Ciudad</label>
                <input type="text" class="form-control" id="city" formControlName="city">
            </div>
    
            <div class="form-group">
                <label for="state">Estado</label>
                <input type="text" class="form-control" id="state" formControlName="state" placeholder="PR" max="2">
            </div>
    
            <div class="form-group">
                <label for="zip">Código Postal</label>
                <input type="text" class="form-control" id="zip" formControlName="zip">
            </div>
    
            <div class="form-group">
                <label for="phone">Teléfono</label>
                <input type="text" class="form-control" id="phone" formControlName="phone">
            </div>
    
            <div class="form-group">
                <label for="email">Email</label>
                <input type="text" class="form-control" id="email" formControlName="email">
            </div>
            <hr>
            <h6>Persona de contacto</h6>
            <div class="form-group">
                <label for="contactPerson">Nombre</label>
                <input type="text" class="form-control" id="contactPerson" formControlName="contact">
            </div>
            <div class="form-group">
                <label for="contactPhone">Teléfono</label>
                <input type="text" class="form-control" id="contactPhone" formControlName="contactPhone">
            </div>
            <div class="form-group">
                <label for="contactEmail">Email</label>
                <input type="text" class="form-control" id="contactEmail" formControlName="contactEmail">
            </div>  
        </div>
        <div *ngIf="missingFieldMsg" class="alert alert-danger" role="alert">
            Falta algun campo...
        </div>
        <div class="modal-footer">
            
            <button type="button" #closeBtn class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button type="submit" class="btn btn-primary">Añadir</button>
        </div>
        </form>
        </div>
    </div>
    </div>